
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
import { GetNewsTems, GetUserTem } from "@/request/common";
import Wang from "@/components/template-transfer-pc/template/components/special/wang.vue";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
import { getCurrentTime } from "@/utils/base";
@Component({
  components: {
    Empty,
    Wang,
  },
})
export default class Name extends mixins(languageMixin) {
  @Prop()
  private part: any;
  private data: any = [];
  private ifOpen: any = false;
  private ifShowSelectCeping: any = false;
  private cepingSelectOptions: any = {};
  private cSelect: any = [];
  private mode3Data: any = {
    舌: null,
    面: null,
    舌下: null,
    脉: null,
  };
  private showLianpai: any = false;
  private sanlianData: any = {};
  private sizhenResult = {}
  private mocksanlianResult = {
    "舌": {
      "data": [
        {
          "type": "舌象80"
        }
      ],
      "report": {
        "舌象照片": {
          "分割前图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg",
          "分割后图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg"
        },
        "舌象信息输出": [
          "青紫",
          "",
          "",
          "黄",
          "厚",
          "有",
          "",
          "",
          "",
          "",
          "",
          "有"
        ],
        "舌色参数": [
          [
            51.61,
            51.61,
            51.61,
            51.61,
            51.61,
            51.61
          ],
          [
            133.94,
            133.94,
            133.94,
            133.94,
            133.94,
            133.94
          ],
          [
            132.91,
            132.91,
            132.91,
            132.91,
            132.91,
            132.91
          ],
          [
            "",
            "",
            "",
            "",
            "",
            ""
          ]
        ],
        "苔色参数": [
          [
            29.37,
            29.37,
            29.37,
            29.37,
            29.37,
            29.37
          ],
          [
            130.07,
            130.07,
            130.07,
            130.07,
            130.07,
            130.07
          ],
          [
            129.48,
            129.48,
            129.48,
            129.48,
            129.48,
            129.48
          ],
          [
            "",
            "",
            "",
            "",
            "",
            ""
          ]
        ],
        "imgs": [
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/f401647d-282c-4241-9ce0-6d8639866771_tongue_upload_1758090087.jpg",
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg"
        ],
        "舌象信息": {
          "舌神": [
            [
              "荣"
            ],
            []
          ],
          "舌色": [
            [
              "青紫"
            ],
            []
          ],
          "舌形": [
            [
              "裂纹"
            ],
            []
          ],
          "舌态": [
            [
              "正常"
            ],
            []
          ],
          "苔质": [
            [
              "厚",
              "腻"
            ],
            []
          ],
          "苔色": [
            [
              "黄"
            ],
            []
          ]
        }
      }
    },
    "舌下": {
      "data": [
        {
          "type": "舌底"
        }
      ],
      "report": {
        "舌象照片": {
          "分割前图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg",
          "分割后图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg"
        },
        "舌象信息输出": [
          "青紫",
          "",
          "",
          "黄",
          "厚",
          "有",
          "",
          "",
          "",
          "",
          "",
          "有"
        ],
        "舌色参数": [
          [
            51.61,
            51.61,
            51.61,
            51.61,
            51.61,
            51.61
          ],
          [
            133.94,
            133.94,
            133.94,
            133.94,
            133.94,
            133.94
          ],
          [
            132.91,
            132.91,
            132.91,
            132.91,
            132.91,
            132.91
          ],
          [
            "",
            "",
            "",
            "",
            "",
            ""
          ]
        ],
        "苔色参数": [
          [
            29.37,
            29.37,
            29.37,
            29.37,
            29.37,
            29.37
          ],
          [
            130.07,
            130.07,
            130.07,
            130.07,
            130.07,
            130.07
          ],
          [
            129.48,
            129.48,
            129.48,
            129.48,
            129.48,
            129.48
          ],
          [
            "",
            "",
            "",
            "",
            "",
            ""
          ]
        ],
        "imgs": [
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/f401647d-282c-4241-9ce0-6d8639866771_tongue_upload_1758090087.jpg",
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg"
        ],
        "舌底信息": {
          "长度": "正常",
          "形态": "双支",
          "颜色": "淡红含浅蓝",
          "粗细": "正常"
        }
      }
    },
    "面": {
      "data": [
        {
          "type": "面象15"
        }
      ],
      "report": {
        "面象照片": {
          "分割前图片": "",
          "分割后图片": ""
        },
        "面色唇色参数": [
          [
            "129.059",
            "112.852",
            "91.6987",
            "97.4189",
            "90.2024",
            "94.664",
            "167.612"
          ],
          [
            "131.075",
            "133.926",
            "131.582",
            "131.688",
            "132.678",
            "130.915",
            "128.276"
          ],
          [
            "134.355",
            "136.54",
            "138.826",
            "135.588",
            "139.36",
            "137.374",
            "127.919"
          ],
          [
            "红黄隐隐，明润含蓄",
            "",
            "",
            "",
            "",
            "",
            "红"
          ]
        ],
        "面象信息输出": [
          "红黄隐隐，明润含蓄",
          "无",
          "无",
          "少量光泽",
          "红"
        ],
        "content_data": [
          {
            "value": {
              "imgs": [
                {
                  "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1ab816a7-a142-4c04-91a0-a15b14d5e7d3_face_upload_1758157618.jpg",
                  "description": "面象原始图片"
                }
              ]
            }
          }
        ],
        "imgs": [
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1ab816a7-a142-4c04-91a0-a15b14d5e7d3_face_upload_1758157618.jpg",
        ],
        "面象信息": {
          "面色": [
            "红黄隐隐，明润含蓄",
            "少量光泽"
          ],
          "唇态": [
            "润"
          ],
          "唇色": [
            "红"
          ],
          "鼻光泽": [
            "有光泽"
          ],
          "鼻形态": [
            "正常"
          ],
          "鼻颜色": [
            "正常肤"
          ],
          "人中形态": [
            "短浅"
          ],
          "人中颜色": [
            "正常肤色"
          ]
        }
      }
    },
    "脉": {
      "data": [
        {
          "type": "脉象6"
        }
      ],
      "report": {
        "pulse_hand": "右手",
        "pulse_pos": "尺脉",
        "连续脉图": "",
        "分段压脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
        "最佳压力脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
        "脉象p-h趋势图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg",
        "脉象信息输出": {
          "脉位": "浮",
          "脉力": "有力",
          "脉名": "大脉",
          "脉率": "慢(71times/min)",
          "流利度": "",
          "紧张度": "",
          "脉节律": "不齐"
        },
        "最佳脉象图参数": {
          "A": 0,
          "t": 0.38,
          "Ad": -5.35326,
          "As": 196.472,
          "h1": 46.0749,
          "h2": 43.1337,
          "h3": 42.9087,
          "h4": 3.07369,
          "h5": -4.37927,
          "t1": 0.172,
          "t2": 0.204,
          "t3": 0.205,
          "t4": 0.308,
          "t5": 0.072,
          "w1": 0.127,
          "w2": 0.087,
          "t1/t": 0.45,
          "w1/t": 0.33,
          "w2/t": 0.23,
          "h3/h1": 0.93,
          "h4/h1": 0.07,
          "h5/h1": -0.1,
          "t5/t4": 0.23
        },
        "imgs": [
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
          "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg"
        ]
      }
    }
  }

  @Watch("patient", { immediate: true })
  private patientChange() {
    this.getData();
  }
  @Watch("systemInfo", { immediate: true })
  private systemInfoChange() {
    this.getData();
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private async getMode3Data() {
    // 需要调取接口拿数据
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: "四诊客观化数据",
      },
    };
    const newstData = await GetNewsTems(this, params, loading);
    //从这里封装一个方法，根据name获取数据
    this.mode3Data["舌"] = await this.getCurrentData(
      newstData.data["四诊客观化数据"],
      "舌"
    );
    this.mode3Data["面"] = await this.getCurrentData(
      newstData.data["四诊客观化数据"],
      "面"
    );
    this.mode3Data["舌下"] = await this.getCurrentData(
      newstData.data["四诊客观化数据"],
      "舌下"
    );
    this.mode3Data["脉"] = await this.getCurrentData(
      newstData.data["四诊客观化数据"],
      "脉"
    );
    this.$forceUpdate();
  }
  private async getCurrentData(arr: any, name: any) {
    let item;
    if (name === "舌") {
      item = arr.find(
        (item: any) => item.name.includes("舌") && !item.name.includes("舌下")
      );
    } else if (name === "舌下") {
      item = arr.find((item: any) => item.name.includes("舌下"));
    } else {
      item = arr.find((item: any) => item.name.includes(name));
    }
    if (item && item.content_id && item.collect_time) {
      const today = getCurrentTime("yyyy-MM-dd");
      if (item.collect_time.includes(today)) {
        return item;
      }
    }
    return null;
  }
  private openSizhen() {
    this.$router.push({
      path: "/main/manage/sizhen-add",
      query: {
        type: this.part.value,
      },
    });
  }
  private getType(item: any, key: any) {
    if (item.template_data.length == 0) {
      return false;
    }
    let type: any = item.template_data[0].type;
    let str: any = "";
    if (type == "舌象" || type == "舌象80" || type == "舌象100") {
      str = "舌";
    } else if (type == "面象" || type == "面象15") {
      str = "面";
    } else if (type == "脉象" || type == "脉象6") {
      str = "脉";
    } else if (type == "舌底" || type == "舌下络脉") {
      str = "舌底";
    } else if (type == "闻诊") {
      str = "闻";
    } else if (type == "手诊") {
      str = "手";
    }
    return str == key;
  }
  private goCaiji(item: any) {
    this.$store.commit("updateIfCompose", true);
    if (item.form_oid == "AI辨证") {
      if (
        !this.mode3Data["舌"] &&
        !this.mode3Data["面"] &&
        !this.mode3Data["舌下"] &&
        !this.mode3Data["脉"]
      ) {
        // this.$message.warning("请先采集舌面脉数据");
        return;
      }
      this.$router.push({
        path: "/main/manage/edit-wen",
        query: {
          template_id: item.id,
          patient_id: this.patient.id,
          name: item.name,
        },
      });
    } else if (item.form_oid == "AI体质") {
      if (
        !this.mode3Data["舌"] &&
        !this.mode3Data["面"] &&
        !this.mode3Data["舌下"] &&
        !this.mode3Data["脉"]
      ) {
        // this.$message.warning("请先采集舌面脉数据");
        return;
      }
      this.$router.push({
        path: "/main/manage/edit-tizhi",
        query: {
          template_id: item.id,
          patient_id: this.patient.id,
          name: item.name,
        },
      });
    } else if (
      item.form_oid == "AI辅助辨证（横）" ||
      item.form_oid == "AI辅助辨证（竖）" ||
      item.form_oid == "AI体质测评（横）" ||
      item.form_oid == "AI体质测评（竖）"
    ) {
      this.sanlianData = item;

      // this.sizhenResult = this.mocksanlianResult;
      // this.jumpToSizhen();
      // return;
      // 这里需要完成舌、舌下、面、脉的拍摄
      this.showLianpai = true;
    } else {
      this.$router.push({
        path: "/main/manage/edit-ceping",
        query: {
          template_id: item.id,
          patient_id: this.patient.id,
          type: this.part.value,
        },
      });
    }
  }
  private confirmLianpai(data: any) {
    console.log('舌面脉拍摄结束');
    console.log(data);
    this.sizhenResult = data;
    this.showLianpai = false;
    this.jumpToSizhen();
  }
  private jumpToSizhen() {
    if (this.sanlianData.form_oid == "AI体质测评（竖）" || this.sanlianData.form_oid == "AI体质测评（横）") {
      this.$router.push({
        path: "/main/manage/edit-AI-tzcp",
        query: {
          template_id: this.sanlianData.id,
          patient_id: this.patient.id,
          name: this.sanlianData.name,
          sizhenResult: JSON.stringify(this.sizhenResult),
        },
      });
    } else if (this.sanlianData.form_oid == "AI辅助辨证（竖）" || this.sanlianData.form_oid == "AI辅助辨证（横）") {
      this.$router.push({
        path: "/main/manage/edit-AI-bianzheng",
        query: {
          template_id: this.sanlianData.id,
          patient_id: this.patient.id,
          name: this.sanlianData.name,
          sizhenResult: JSON.stringify(this.sizhenResult),
        },
      });
    }

  }
  private clickCeping(item: any) {
    const index = this.getIndex(this.cSelect, item, "id");
    if (index == -1) {
      this.cSelect.push(item);
    } else {
      this.cSelect.splice(index, 1);
    }
    this.$forceUpdate();
  }
  private addCepingSave() {
    if (this.cSelect.length == 0) {
      this.$message.warning("请选择测评量表");
      return;
    }
    this.$store.commit("updateIfCompose", true);
    this.$router.push({
      path: "/main/manage/edit-ceping-group",
      query: {
        patient_id: this.patient.id,
        data: JSON.stringify(this.cSelect),
        type: "健康测评数据",
      },
    });
  }
  private getIndex(arr: any, item: any, key: any) {
    const index: any = arr.findIndex((val: any) => {
      return val.id == item[key];
    });
    return index;
  }
  private openAddCeping() {
    this.cSelect = [];
    this.cepingSelectOptions = [];
    const params: any = {
      params: {
        related_type: "健康测评数据",
        // related_type: this.part.value,
        patient_id: this.patient.id,
      },
    };
    GetUserTem(this, params).then((res: any) => {
      this.cepingSelectOptions = res.data;
      this.$forceUpdate();
      this.ifShowSelectCeping = true;
    });
  }
  private goDetail(item: any) {
    if (
      !item.content_id ||
      item.form_oid == "AI辨证" ||
      item.form_oid == "AI体质" ||
      item.form_oid == "AI望诊"
    ) {
      return;
    }
    this.$store.commit("updateIfCompose", false);
    if (this.part.value == "健康测评数据") {
      this.$router.push({
        path: "/main/manage/edit-ceping",
        query: {
          template_id: item.id,
          patient_id: this.patient.id,
          content_id: item.content_id,
        },
      });
    } else {
      this.$router.push({
        path: "/main/manage/edit-ceping",
        query: {
          template_id: item.id,
          patient_id: this.patient.id,
          content_id: item.content_id,
        },
      });
    }
  }
  private getShowData(arr: any) {
    let d: any = [];
    if (arr.length < 5 || this.ifOpen) {
      d = arr;
    } else {
      d = arr.slice(0, 4);
    }
    return d;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: this.part.value,
      },
    };
    GetNewsTems(this, params, loading).then((res: any) => {
      this.data = res.data[this.part.value];
      this.getMode3Data();
    });
  }
  private mounted() { }
}
